<template>
    <div class="form-container">
        <template v-if="isAuth">
            <div v-if="message == ''" class="form">
                <h2>Rate Service</h2>
                <p class="form-subheading">Add an internal rating for your use only. Or send a rating to the vendor. <br />
                    All ratings are reviewed for compliance with Our <a class="truckdown-link" href="/terms/rating" title="Our rating policy">Rating Policy</a>.
                </p>

                <div class="inputs-container">
                    <div class="methods-container">
                        <button :class="type == 'internal' ? 'active' : ''" @click="selectInternal">
                            <fa-icon :icon="['fas', 'user-lock']" aria-hidden="true"></fa-icon>Create an Internal Rating
                        </button>


                        <button :class="type == 'public' ? 'active' : ''" @click="selectPublic">
                            <fa-icon :icon="['fas', 'bullhorn']" aria-hidden="true"></fa-icon>Create a Public Rating
                        </button>
                    </div>

                    <div class="form-fields">
                        <label class="rating-label">Rating value ({{ state.value }} out of 5)</label>
                        <div>
                            <span class="rating-input" @mouseout="resetDisplayValue()">
                                <a href="#" :title="ratingTitle" @mouseover="setDisplayValue(1, $event)" @mousemove="setDisplayValue(1, $event)" @click.prevent="setValue(1, $event)">
                                    <span v-if="displayValue == 0.5"><fa-icon :icon="['far', 'star-half-stroke']" aria-hidden="true"></fa-icon></span>
                                    <span v-if="displayValue >= 1"><fa-icon :icon="['fas', 'star']" aria-hidden="true"></fa-icon></span>
                                    <span v-if="displayValue < 0.5"><fa-icon :icon="['far', 'star']" aria-hidden="true"></fa-icon></span>
                                </a>
                                <a href="#" :title="ratingTitle" @mouseover="setDisplayValue(2, $event)" @mousemove="setDisplayValue(2, $event)" @click.prevent="setValue(2, $event)">
                                    <span v-if="displayValue == 1.5"><fa-icon :icon="['far', 'star-half-stroke']" aria-hidden="true"></fa-icon></span>
                                    <span v-if="displayValue >= 2"><fa-icon :icon="['fas', 'star']" aria-hidden="true"></fa-icon></span>
                                    <span v-if="displayValue < 1.5"><fa-icon :icon="['far', 'star']" aria-hidden="true"></fa-icon></span>
                                </a>
                                <a href="#" :title="ratingTitle" @mouseover="setDisplayValue(3, $event)" @mousemove="setDisplayValue(3, $event)" @click.prevent="setValue(3, $event)">
                                    <span v-if="displayValue == 2.5"><fa-icon :icon="['far', 'star-half-stroke']" aria-hidden="true"></fa-icon></span>
                                    <span v-if="displayValue >= 3"><fa-icon :icon="['fas', 'star']" aria-hidden="true"></fa-icon></span>
                                    <span v-if="displayValue < 2.5"><fa-icon :icon="['far', 'star']" aria-hidden="true"></fa-icon></span>
                                </a>
                                <a href="#" :title="ratingTitle" @mouseover="setDisplayValue(4, $event)" @mousemove="setDisplayValue(4, $event)" @click.prevent="setValue(4, $event)">
                                    <span v-if="displayValue == 3.5"><fa-icon :icon="['far', 'star-half-stroke']" aria-hidden="true"></fa-icon></span>
                                    <span v-if="displayValue >= 4"><fa-icon :icon="['fas', 'star']" aria-hidden="true"></fa-icon></span>
                                    <span v-if="displayValue < 3.5"><fa-icon :icon="['far', 'star']" aria-hidden="true"></fa-icon></span>
                                </a>
                                <a href="#" :title="ratingTitle" @mouseover="setDisplayValue(5, $event)" @mousemove="setDisplayValue(5, $event)" @click.prevent="setValue(5, $event)">
                                    <span v-if="displayValue == 4.5"><fa-icon :icon="['far', 'star-half-stroke']" aria-hidden="true"></fa-icon></span>
                                    <span v-if="displayValue >= 5"><fa-icon :icon="['fas', 'star']" aria-hidden="true"></fa-icon></span>
                                    <span v-if="displayValue < 4.5"><fa-icon :icon="['far', 'star']" aria-hidden="true"></fa-icon></span>
                                </a>
                            </span>

                        </div>
                        <div class="input-errors" v-for="error of v$.value.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                        </div>
                    </div>

                    <div class="form-fields">
                        <label>{{ noteLabel }}</label>
                        <div :class="{ error: v$.note.$errors.length }">
                            <textarea v-model="state.note" @blur="v$.note.$touch"></textarea>
                            <div class="input-errors" v-for="error of v$.note.$errors" :key="error.$uid">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="checkbox-container" v-if="isAce">
                        <div v-if="showAddAvoid">
                            <label class="checkbox-label">
                                <span class="capital truckdown-orange">Avoid</span> - add this vendor to my Avoid list so that the listing no longer shows in my search results.
                                <input type="checkbox" v-model="setPreferred" />
                                <span class="mark"></span>
                            </label>
                        </div>
                        <div v-if="showAddFavorite">
                            <label class="checkbox-label">
                                <span class="capital truckdown-orange">Favorite</span> - put your best vendors at the top of search results in this area.
                                <input type="checkbox" v-model="setPreferred" />
                                <span class="mark"></span>
                            </label>
                        </div>
                        <div v-if="showClearPreferred">
                            <label class="checkbox-label">
                                {{ labelClearPreferred }}
                                <input type="checkbox" v-model="setPreferred" />
                                <span class="mark"></span>
                            </label>
                        </div>
                    </div>

                </div>

                <div class="form-buttons">
                    <button class="cancel-btn" @click="closeForm">Cancel</button>
                    <button class="forward-btn" @click="submit">{{ saveLabel }}</button>
                </div>

            </div>
            <div class="info-message" v-else>
                <div class="message">
                    <p>{{ message }}</p>
                </div>
                <div class="xmark">
                    <fa-icon :icon="['fas', 'xmark']" aria-hidden="true" @click="closeForm"></fa-icon>
                </div>
            </div>
        </template>
        <template v-else>
            <marketing-action class="py-0" :more-info-url="moreInfoUrl">
                <template #heading>
                    <h2>Rate Service</h2>
                    <p>Add an internal rating for your use only or send a rating to the vendor. <br />All ratings are reviewed for compliance with Our <a class="truckdown-link" href="/terms/rating">Rating Policy</a>.</p>
                </template>
                <template #subheading>
                    <h3>This is a free feature available to logged-in accounts</h3>
                    <h4>Create a <strong>free account</strong> or <strong>login</strong> to rate this vendor!</h4>
                </template>
            </marketing-action>
        </template>
    </div>
</template>

<script>import script from './ListingRateService';
    export default script;</script>

<style lang="less" scoped>
    @import "./ListingRateService.less";
</style>
